import React from "react";
import { FaInstagram, FaLinkedinIn } from "react-icons/fa";
import Logo from "../Assets/logo.png";
import { useLanguage } from "../i18n";

const Footer = () => {
  const { t } = useLanguage();
  return (
  <footer>
    <div className="footer-wrapper">
      <div className="footer-logo-container">
        <img src={Logo} alt="Pranesh Enterprises" />
        <p>{t.footerTagline}</p>
        <div className="footer-icons" aria-label="Social media links">
          <a
            href="https://www.linkedin.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Pranesh Enterprises on LinkedIn"
            title="LinkedIn"
          >
            <FaLinkedinIn />
          </a>
          <a
            href="https://www.instagram.com/praneshenterprises.ind/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Pranesh Enterprises on Instagram"
            title="Instagram"
          >
            <FaInstagram />
          </a>
        </div>
      </div>
      <div className="footer-section-two">
        <div className="footer-section-columns">
          <h2 className="primary-subheading">{t.products}</h2>
          <a href="#products">Analytical Instruments</a>
          <a href="#products">Life Sciences Equipment</a>
          <a href="#products">General Lab Equipment</a>
          <a href="#products">Microscopy</a>
          <a href="#products">Sample Preparation</a>
        </div>
        <address className="footer-section-columns">
          <h2 className="primary-subheading">{t.contact}</h2>
          <span>Pranesh Enterprises</span>
          <span>54 Rathinam Nagar</span>
          <span>Pollachi, Coimbatore 642001</span>
          <a href="tel:+918668012264">+91 86680 12264</a>
          <a href="mailto:praneshenterprises.ind@gmail.com">
            praneshenterprises.ind@gmail.com
          </a>
        </address>
      </div>
    </div>
    <div className="footer-bottom">
      Copyright © 2026 Pranesh Enterprises. All rights reserved.
    </div>
  </footer>
  );
};

export default Footer;
